import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35d26446&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=35d26446&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=35d26446&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d26446",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d26446')) {
      api.createRecord('35d26446', component.options)
    } else {
      api.reload('35d26446', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35d26446&scoped=true&", function () {
      api.rerender('35d26446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/link-modal/index.vue"
export default component.exports